import { TooltipButton } from "@/v2-backoffice-client/components/button"
import { useTableExport } from "./table.export"

export type TableExportSelectionButtonProps = {
  fileName: string
  selectionCount: number
  addTimestampToFileName?: boolean
}

function TableExportSelectionButton(props: TableExportSelectionButtonProps) {
  const { fileName, selectionCount, addTimestampToFileName = true } = props
  const { exportToExcel, isExporting } = useTableExport({
    fileName,
    addTimestampToFileName,
  })

  return (
    <TooltipButton
      variant="ghost"
      isStacked
      isLoading={isExporting}
      iconSrc="file-export"
      content={`Export ${selectionCount} selected rows to Excel`}
      disabled={isExporting}
      onClick={() => {
        exportToExcel(true)
      }}
    >
      Export
    </TooltipButton>
  )
}

export default TableExportSelectionButton
